import { Observable, of, tap, shareReplay } from 'rxjs';
import { CacheItem } from '../models/cache-item.model';

export class CacheService<T> {
    private cache: Map<string, CacheItem<T>> = new Map();

    public getOrSet(key: string, observable: Observable<T>): Observable<T> {
        const cacheItem = this.cache.get(key);

        if (cacheItem?.status === 'loaded' && cacheItem.data !== undefined) {
            return of(cacheItem.data);
        }
        if (cacheItem?.status === 'loading' && cacheItem.observable !== undefined) {
            return cacheItem.observable;
        }

        const loadingObservable = observable.pipe(
            tap((data) => this.set(key, data)),
            shareReplay(1)
        );

        this.cache.set(key, { status: 'loading', observable: loadingObservable });

        return loadingObservable;
    }

    public set(key: string, value: T): void {
        this.cache.set(key, { status: 'loaded', data: value });
    }

    public invalidate(key: string): void {
        this.cache.delete(key);
    }
}
